<!-- Context Menu -->
<p-contextMenu #cm [model]="menuItems" [appendTo]="'body'"></p-contextMenu>

<!-- Toast notifications -->
<p-toast key="main"></p-toast>

<!-- Modern Header Section -->
<div class="mt-4 ml-4 mr-4 header-section">
  <div class="header-content">
    <div class="header-left">
      <h1 class="page-title">
        <i class="pi pi-user"></i>
        Clinics
      </h1>
      <p class="page-subtitle">Manage your assigned clinics</p>
    </div>
  </div>
</div>

<!-- Main Content Area -->
<div class="mt-4 nurse-dashboard-content">
  <div class="content-section">
    <div class="section-header">
      <div class="header-info">
        <h2 class="section-title">My Clinics</h2>
        <p class="section-description">Manage your assigned clinics</p>
      </div>
    </div>

    <div class="overflow-auto">
      <p-table
        #myClinicTable
        [value]="clinics"
        [paginator]="true"
        [rows]="10"
        (onLazyLoad)="loadClinicsLazy($event)"
        [lazy]="true"
        [contextMenu]="cm"
        [(contextMenuSelection)]="selectedRow"
        scrollHeight="50vh"
        [totalRecords]="metaData.totalRecords"
        [loading]="metaData.loading"
        [(first)]="metaData.offset"
        [(rows)]="metaData.limit"
        [scrollable]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} clinics"
        class="modern-table"
        [showCurrentPageReport]="true"
        [rowsPerPageOptions]="[10, 25, 50, 100]"
      >
        <ng-template pTemplate="caption">
          <div class="table-search">
            <div class="search-container">
              <i class="pi pi-search search-icon"></i>
              <input
                pInputText
                type="text"
                name="globalFilter"
                (input)="
                  myClinicTable.filterGlobal(
                    getFilterInputValueForNurse($event),
                    'contains'
                  )
                "
                placeholder="Search clinics..."
                class="modern-search"
              />
            </div>
          </div>
        </ng-template>

        <ng-template pTemplate="header">
          <tr class="table-header">
            <th *ngFor="let col of clinicColumns" [pSortableColumn]="col.field">
              <div class="header-cell">
                {{ col.header }}
              </div>
            </th>
         
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-clinic let-columns="columns">
          <tr
            class="table-row"
          >
            <td *ngFor="let col of clinicColumns" class="table-cell">
              <div class="cell-content">
                <span class="cell-text">
                  {{ clinic[col.field] }}
                </span>
              </div>
            </td>
           
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="clinicColumns.length" class="empty-state">
              <p-progressBar *ngIf="metaData.loading" mode="indeterminate">
              </p-progressBar>

              <div *ngIf="!metaData.loading" class="empty-content">
                <i class="pi pi-user-nurse empty-icon"></i>
                <h3>No clinics found</h3>
                <p>No clinics are currently assigned to you</p>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
